import React, { useEffect, useState } from 'react';
import { Box, Typography, Pagination, Divider } from '@mui/material';
import Grid from "@mui/material/Grid";
import CustomButton from '../../Components/Button/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import Button from "@mui/material/Button";
import './VcoiManagePolicyAndEmailSetting.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeletePolicyandEmailSetting, V_GetPolicyandEmailSetting } from "../../Reducers/dcoi";
import InputControl from '../../Components/Common/TextField/TextField';  // Custom input component
import ConfirmationModel from '../../Components/Common/DeleteModel/DeleteModel';
import Spinner from '../../Components/Common/Spinner/Spinner';
import CheckIcon from '@mui/icons-material/Check';

function ManagePolicyAndEmailSetting() {
  const {V_PolicyAndEmailSetting, inProgress } = useSelector(
    (state) => state.dcoi
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const[itemId,setItemId]=useState();
  const [filteredData, setFilteredData] = useState(V_PolicyAndEmailSetting || []);  // State for filtered data
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteModel, setDeleteModel] = useState(false);  // State for the search query

  useEffect(() => {
    // dispatch(GetAllPolicies());
    dispatch(V_GetPolicyandEmailSetting());
  }, [dispatch]);

  useEffect(() => {
    if (V_PolicyAndEmailSetting?.length > 0) {
      setFilteredData(V_PolicyAndEmailSetting); // Update filteredPolicies with the fetched data
    }
  }, [V_PolicyAndEmailSetting]);



  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  // Search handler that triggers on button click
  const handleSearchClick = () => {
    const filtered = V_PolicyAndEmailSetting.filter((item) => 
      item.HfmCode.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.EntityAdminGroup.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    setFilteredData(filtered); // Update filtered data based on search query
    setCurrentPage(1); // Reset to first page after search
  };
  

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Search input handler
  const handleSearchChange = (e) => {
    setSearchQuery(e);  // Update search query as the user types
  };


  const SucessDelete = () => {
dispatch(DeletePolicyandEmailSetting(itemId)).then((res)=>{
  if(res.payload.status===200){
    setDeleteModel(!deleteModel)
    dispatch(V_GetPolicyandEmailSetting());
  }
})
  }

  const DeleteRecord = (item) => {
    setItemId(item)
    setDeleteModel(true)
  }

  return (
    <>
      <ConfirmationModel open={deleteModel} handleOpen={() => setDeleteModel(!deleteModel)} SucessDelete={SucessDelete} />
      <div className='headerNavigation'>
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>List of Policy and Email Settings</Typography>
      </div>

      <Box className='boxAlignment'>
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <InputControl
                  placeholder="Search by HFM Code & Entity Admin Group"
                  value={searchQuery}            // Bind value to searchQuery state
                  onChange={handleSearchChange}   // Pass the event to handleSearchChange
                />
              </Box>
              <Button
                sx={{backgroundColor:"#212129",color:"white",padding:"8px",borderRadius:"0px"}}
                startIcon={<SearchIcon className="actionIcon" />}
                onClick={handleSearchClick} // Trigger search functionality on button click
              >
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <CustomButton onClick={() => navigate(`/app-vcoi/vcoisitecontent/VcoiNewPolicyAndEmailSettingHome`)} label="+ ADD NEW MAPPING" />
          </Grid>
        </Grid>
        <Box sx={{ margin:"20px",overflowX: "auto", width: "100%"}}>
          <Box sx={{minWidth:"700px"}}>

          <Grid container my={2} spacing={2} alignItems="flex-start" sx={{ fontWeight: "bold", color: "gray"}} >
          <Grid item xs={2} sm={2} md={2}>
            HFM CODE
          </Grid>
          <Grid item xs={3} sm={3} md={3}>
            ENTITY ADMIN GROUP
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            MAPPING
          </Grid>
          <Grid item xs={3} sm={3} md={3}></Grid>
        </Grid>
        <Divider />
        {filteredData.length > 0 ? (
  currentItems.map((item, index) => (
    <React.Fragment key={index}>
      <Grid container alignItems="flex-start" spacing={2} sx={{alignItems: "center",padding:"10px 0px" }}>
        <Grid item xs={2} sm={2} md={2}>
          <Typography>{item.HfmCode}</Typography>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <Typography>{item.EntityAdminGroup}</Typography>
        </Grid>
        <Grid item xs={4} sm={4} md={4}>
          {item.Mappings && Array.isArray(item.Mappings) && item.Mappings.map((data, idx) => (
            <Box key={idx} sx={{
              margin:"5px 0px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "left",
              alignItems: "left",
              padding: "5px 10px",
              border: "1px dotted #212129",
            }}>
              {data.Mapping}&nbsp;&nbsp;
              {data.isDefaultMapping ?<span className="mappingStyle">
                Default <CheckIcon/>
              </span>:"" }
              
            </Box>
          ))}
        </Grid>
        <Grid item xs={3} sm={3} md={3} sx={{ display: {xs:"none",sm:"none",md:"flex"},justifyContent: "right" }}>
          <Button className='actionButton' variant="contained" startIcon={<DeleteIcon className='actionIcon' />} onClick={() => DeleteRecord(item)}>
            Delete
          </Button>
          &nbsp;&nbsp;
          <Button className='actionButton' variant="contained" onClick={() => navigate('/app-vcoi/vcoisitecontent/VcoiNewPolicyAndEmailSettingHome', { state: { settingData: item } })} startIcon={<EditIcon className='actionIcon' />}>
            Edit
          </Button>
        </Grid>
        <Grid item xs={3} sm={3} md={3} sx={{ display: {xs:"flex",sm:"flex",md:"none"},justifyContent: "left" }}>
          <DeleteIcon className='actionIconResponsive'  onClick={() => DeleteRecord(item)} />
          &nbsp;&nbsp;
<EditIcon className='actionIconResponsive' onClick={() => navigate('/app-vcoi/vcoisitecontent/VcoiNewPolicyAndEmailSettingHome', { state: { settingData: item } })} />
        </Grid>
      </Grid>
      <Divider/>
    </React.Fragment>
  ))
) : (
  <>
    {(!inProgress && currentItems?.length === 0 )|| V_PolicyAndEmailSetting?.length === 0 ? (
      <Typography sx={{ margin: "20px", textAlign: "center", color: "gray", fontStyle: "italic" }}>
        No Data Found...
      </Typography>
    ) : ""}
  </>
)}
</Box>
</Box>
        {currentItems.length > 0 &&  <Box sx={{display:"flex",justifyContent:"center"}}>
            <Pagination showFirstButton showLastButton sx={{ margin: "10px", padding:"5px",   border: "1px solid #212129",
    borderRadius: "20px" }} count={Math.ceil(filteredData.length / itemsPerPage)} page={currentPage} onChange={handlePageChange} /></Box>}
      </Box>
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default ManagePolicyAndEmailSetting;
